import uuidv1 from 'uuid/v1';

// HEAD DATA
export const headData = {
  title: "Balaji Ashok Kumar (BK)'s Portfolio", // e.g: 'Name | Developer'
  lang: '', // e.g: en, es, fr, jp
  description: "Welcome to BK's Portfolio", // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: "Hello, I'm",
  name: 'Balaji Ashok Kumar (BK)',
  subtitle: 'I like to make stuff with code',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.png',
  paragraphOne: 'I am a Full Stack developer with industry experience building websites and web applications. I specialize in Java, JavaScript, HTML5, CSS3 and have professional experience working with React and Angular.',
  paragraphTwo: 'I am passionate about building scalable software, creating effective solutions, and learning every day to grow professionally in the IT field.',
  paragraphThree: 'Feel free to contact me at any time.',
  resume: '', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: uuidv1(),
    img: 'clothing-ecommerce.png',
    title: 'Clothing Ecommerce',
    info: 'An online shopping website for clothes.',
    info2: 'This website is developed using React, React-Router, Redux and Firebase.',
    url: 'https://clothing-ecommerce.netlify.com/',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: uuidv1(),
    img: 'covid-19.png',
    title: 'COVID-19 Tracker',
    info: 'This tracker aims to show the numbers & trends of people affected, recovered and deceased due to COVID-19.',
    info2: 'I developed this website using React, Material UI, Chart.js and Axios.',
    url: 'https://covid19trackerbk.netlify.app/',
    repo: 'https://github.com/dynamicbalaji/covid19-tracker', // if no repo, the button will not show up
  },
  {
    id: uuidv1(),
    img: 'project.jpg',
    title: '',
    info: '',
    info2: '',
    url: '',
    repo: 'https://github.com/dynamicbalaji', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: 'dynamicbalaji4u@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: uuidv1(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/balaji-ashok-kumar/',
    },
    {
      id: uuidv1(),
      name: 'github',
      url: 'https://github.com/dynamicbalaji',
    },
    {
      id: uuidv1(),
      name: 'medium',
      url: 'https://medium.com/@dynamicbalaji',
    },
    {
      id: uuidv1(),
      name: 'twitter',
      url: 'https://twitter.com/dynamicbalaji',
    },
    {
      id: uuidv1(),
      name: 'free-code-camp',
      url: 'https://www.freecodecamp.org/dynamicbalaji',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
